<template>
  <v-btn
    color="primary"
    outlined
    :small="isMobile"
    class="text-uppercase"
    @click="onClick"
  >
    <img
      src="/images/play_icon_blue.svg"
      width="25px"
    >
    <span class="first-letter-capitalize ml-2">
      Assista ao videocast
    </span>
  </v-btn>
</template>
<script>
import { mapGetters } from "vuex";
import ActiveTabMixin from './ActiveTabMixin'

export default {
  mixins: [ActiveTabMixin],
  computed: {
    ...mapGetters(['module','contents']),
  },
  methods: {
    onClick(){
      const tab = this.contents.length
      console.log(tab)
      this.activeTab = tab
    }
  }
}
</script>
